module.exports = __webpack_public_path__ + "868bf6c7df75e57c5e36c70da555066c.pdf";